"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));

var _InlineSVG = _interopRequireDefault(require("../InlineSVG"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _dec3, _class, _class2, _temp;

var styles = {
  componentId: 'bHbtJ',
  template: function template(theme) {
    return "\n\n.bHbtJ_bGBk{color:inherit;fill:currentColor;height:1em;line-height:1;vertical-align:middle;width:1em}\n\n.bHbtJ_cwgF{transform:rotate(90deg)}\n\n.bHbtJ_exaY{transform:rotate(180deg)}\n\n.bHbtJ_dTDN{transform:rotate(270deg)}\n\n[dir=rtl] .bHbtJ_owrh{transform:scaleX(-1)}\n\n[dir=rtl] .bHbtJ_owrh.bHbtJ_cwgF{transform:scaleX(-1) rotate(90deg)}\n\n[dir=rtl] .bHbtJ_owrh .bHbtJ_exaY{transform:scaleX(-1) rotate(180deg)}\n\n[dir=rtl] .bHbtJ_owrh .bHbtJ_dTDN{transform:scaleX(-1) rotate(270deg)}\n\n.bHbtJ_dIzR{font-size:".concat(theme.sizeXSmall || 'inherit', "}\n\n.bHbtJ_VCXp{font-size:").concat(theme.sizeSmall || 'inherit', "}\n\n.bHbtJ_fKcQ{font-size:").concat(theme.sizeMedium || 'inherit', "}\n\n.bHbtJ_cnhd{font-size:").concat(theme.sizeLarge || 'inherit', "}\n\n.bHbtJ_fWMB{font-size:").concat(theme.sizeXLarge || 'inherit', "}");
  },
  'root': 'bHbtJ_bGBk',
  'rotate--90': 'bHbtJ_cwgF',
  'rotate--180': 'bHbtJ_exaY',
  'rotate--270': 'bHbtJ_dTDN',
  'bidirectional': 'bHbtJ_owrh',
  'size--x-small': 'bHbtJ_dIzR',
  'size--small': 'bHbtJ_VCXp',
  'size--medium': 'bHbtJ_fKcQ',
  'size--large': 'bHbtJ_cnhd',
  'size--x-large': 'bHbtJ_fWMB'
};

/**
---
category: components/utilities
---
**/
var SVGIcon = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec3 = (0, _deprecated.default)('5.0.0', {
  width: 'size',
  height: 'size'
}), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SVGIcon, _Component);

  function SVGIcon() {
    (0, _classCallCheck2.default)(this, SVGIcon);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SVGIcon).apply(this, arguments));
  }

  (0, _createClass2.default)(SVGIcon, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          rotate = _this$props.rotate,
          className = _this$props.className,
          size = _this$props.size,
          bidirectional = _this$props.bidirectional,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["rotate", "className", "size", "bidirectional"]);
      return _react.default.createElement(_InlineSVG.default, Object.assign({}, props, {
        rotate: rotate,
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles["rotate--".concat(rotate)], rotate && rotate !== '0'), (0, _defineProperty2.default)(_classnames, styles["size--".concat(size)], size), (0, _defineProperty2.default)(_classnames, styles.bidirectional, bidirectional), (0, _defineProperty2.default)(_classnames, className, className), _classnames))
      }));
    }
  }]);
  SVGIcon.displayName = "SVGIcon";
  return SVGIcon;
}(_react.Component), _class2.propTypes = (0, _objectSpread2.default)({}, _InlineSVG.default.propTypes, {
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  rotate: _propTypes.default.oneOf(['0', '90', '180', '270']),
  size: _propTypes.default.oneOf(['x-small', 'small', 'medium', 'large', 'x-large']),
  bidirectional: _propTypes.default.bool
}), _class2.defaultProps = {
  rotate: '0',
  bidirectional: false,
  width: void 0,
  height: void 0,
  size: void 0
}, _temp)) || _class) || _class) || _class);
var _default = SVGIcon;
exports.default = _default;